// extracted by mini-css-extract-plugin
export default {"modeCircle":"nav_modeCircle__oHHmp","sub_sec":"nav_sub_sec__lr4gf"};